import styled from 'styled-components';

export const Container = styled.div`
   display: flex;
   width: 100%;
   height: 100%;
   padding: 10px;
   align-items: center;
   justify-content: space-between;
   user-select: none;
    > div {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.75rem;
        > span  {
            font-size: 15px;
            color: #8c8787;
        }
    }
    div:disabled {
        opacity: 0.5;
        cursor:no-drop;
    }
    .icTs{
        font-size: 1.7rem;
        color: #8c8787;
        cursor: pointer;
        &:hover{
            color: #ff000091;
        }
    };
`
export const BtnGeneration = styled.button`
    display: flex;
    height: 30px;
    width: 140px;
    outline: none;
    border:none; 
    border-radius: 4px;
    font-size: 11.75px;
    text-align: center;
    background-color: #1b72d6;
    color: #ffffff;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    &:not(:disabled):hover {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    &:disabled {
        /* pointer-events:none; */
        opacity: 0.5;
        cursor:no-drop;
    }
`;

export const Load = styled.div`
    display: inline-block;
    position: relative;
    width: 40px;
    height: 100%;
    div{
        position: absolute;
        top: 10px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color:#ffffff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    div:nth-child(1) {
        left: 4px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    div:nth-child(2) {
        left: 4px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    div:nth-child(3) {
        left: 16px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    div:nth-child(4) {
        left: 28px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(12px, 0);
        }
    }
`;